


<div>
  <div style="margin-left: 80%; margin-bottom: 2%;" class="noPrint">
    <button [useExistingCss]="true"
            style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;"
            mat-raised-button color="primary"  printSectionId="print-section" ngxPrint>
      Print
    </button>
    <button mat-dialog-close class="btn" style="z-index: 10">Close</button>
  </div>

  <div class="wrapper" id="print-section">

    <script type="text/javascript">
        window.onload = addPageNumbers;

        function addPageNumbers() {
            var totalPages = Math.ceil(document.body.scrollHeight / 1123);  //842px A4 pageheight for 72dpi, 1123px A4 pageheight for 96dpi, 
            for (var i = 1; i <= totalPages; i++) {
                var pageNumberDiv = document.createElement("div");
                var pageNumber = document.createTextNode(" पृष्ठ क्र. " + i + " of " + totalPages);
                pageNumberDiv.style.position = "absolute";
                pageNumberDiv.style.marginTop = "calc((" + i + " * (297mm - 0.5px)) - 40px)"; //297mm A4 pageheight; 0,5px unknown needed necessary correction value; additional wanted 40px margin from bottom(own element height included)
                pageNumberDiv.style.height = "16px";
                pageNumberDiv.appendChild(pageNumber);
                document.body.insertBefore(pageNumberDiv, document.getElementById("content"));
                pageNumberDiv.style.left = "calc(100% - (" + pageNumberDiv.offsetWidth + "px + 20px))";
            }
        }
    </script>

    <!-- Fixed Header -->
    <div class="header">
      <span>वर्गणी बाकी असलेले</span> - 
      <!-- <span *ngIf="delivery_mode != ''" style="margin-left: 1%;">वितरण - {{ deliveryMode }}</span>
      <span *ngIf="rep_name != ''" style="margin-left: 1%; display: flex; flex-direction: column;">
        <span>प्रतिनिधी पासून - {{ firstRepName }}</span>
        <span>प्रतिनिधी पर्यंत - {{ lastRepName }}</span>
      </span>
      <span *ngIf="district != ''" style="margin-left: 1%;">जिल्हा - {{ district[0] }}</span>
      <span *ngIf="taluka != ''" style="margin-left: 1%;">तालुका - {{ taluka[0] }}</span> -->

                <span *ngIf="start_date">पासुन दिनांक: {{ start_date | date:'dd-MM-yyyy' }} | </span>
                <span *ngIf="end_date">पर्यत दिनांक: {{ end_date | date:'dd-MM-yyyy' }} | </span>
                <span *ngIf="country">देश: {{ country }} | </span>
                <span *ngIf="state">राज्य: {{ state }} | </span>
                <span *ngIf="district">जिल्हा: {{ district }} | </span>
                <span *ngIf="taluka">तालुका: {{ taluka }} | </span>
                <span *ngIf="prant_name">पिन कोड: {{pincode}}</span>
                <span *ngIf="rep_name">प्रतिनिधी: {{ rep_name }} | </span>
                <span *ngIf="delivery_mode">वितरण मोड: {{ delivery_mode }} | </span>
                <span *ngIf="sub_type">सदस्यता प्रकार: {{ sub_type }} | </span>
                <span *ngIf="prant_name">प्रांत: {{ prant_name }}</span>
    </div>

    <!-- Content Grid -->
    <div class="print-grid">
      <ng-container *ngFor="let data2 of AllAdd; let i = index">
        <div class="grid-item">
          <span style="font-size: 13px; font-weight: bold;">
            {{ data2['sub_no'] }}
          </span><br />

          <span *ngIf="data2.address?.length > 84" style="font-size: 14px; font-weight: bold;">
           {{ data2["name"] }}
          </span>
          <span *ngIf="data2.address?.length <= 84" style="font-size: 14px; font-weight: bold;">
            {{ data2["title"] }} {{ data2["name"] }}
          </span><br />

          <span style="font-weight: bold; display: block;"
                [style.font-size.px]="data2.address?.length > 84 ? 12 : 14">
            {{ data2["address"] }}
          </span>
          <span *ngIf="data2.taluka" style="font-weight: bold; display: block;"
                [style.font-size.px]="data2.address?.length > 84 ? 12 : 14">
            {{ data2["taluka"] }} ,{{ data2["district"] }} - {{ data2["pincode"] }}
          </span>
          <span *ngIf="data2['pincode'] != 0" style="font-weight: bold;"
                [style.font-size.px]="data2.address?.length > 84 ? 12 : 14">
            <!-- <span *ngIf="data2.district">{{ data2["district"] }} - </span> -->
            <!-- {{ data2["pincode"] }} {{ data2["state"] }}  -->
             मो.क्र.-{{ data2["mobileNumber"] }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>


<!-- OLD Correct Code  -->
 <!-- <div>
    <div style="margin-left: 70%;  margin-bottom: 2%">
        <button
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'12px', 'font-weight':'400', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'15px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
            class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"   [useExistingCss]="true"
            
            printSectionId="print-section" ngxPrint>
            Print
        </button>
        <button mat-dialog-close class="btn noPrint">
            Close
        </button>
    </div>

<table  class="table table-bordered" id="print-section">
    <thead>
        <tr>
            <th colspan="1">Pending Address
            <div style="font-size: 10px; font-weight: 600; margin-bottom: 4px;" class="print-header">
                <span *ngIf="start_date">पासुन दिनांक: {{ start_date | date:'dd-MM-yyyy' }} | </span>
                <span *ngIf="end_date">पर्यत दिनांक: {{ end_date | date:'dd-MM-yyyy' }} | </span>
                <span *ngIf="country">देश: {{ country }} | </span>
                <span *ngIf="state">राज्य: {{ state }} | </span>
                <span *ngIf="district">जिल्हा: {{ district }} | </span>
                <span *ngIf="taluka">तालुका: {{ taluka }} | </span>
                <span *ngIf="prant_name">पिन कोड: {{pincode}}</span>
                <span *ngIf="rep_name">प्रतिनिधी: {{ rep_name }} | </span>
                <span *ngIf="delivery_mode">वितरण मोड: {{ delivery_mode }} | </span>
                <span *ngIf="sub_type">सदस्यता प्रकार: {{ sub_type }} | </span>
                <span *ngIf="prant_name">प्रांत: {{ prant_name }}</span>
                
              </div>
            </th>
        </tr>
    </thead>

    <tbody>
        <div class="row" style="margin-top: 1%;">
            <div class="col-3" style="padding: 40px; font-weight: 40px;" *ngFor="let data2 of AllAdd; let i = index">
                <b>   {{data2.sub_no}}<br> {{data2.name}} <br> {{data2.address}} <br>{{data2.taluka}} <br> {{data2.district}} - {{data2.pincode}} {{data2.state}} <br> 
                    मो.क्र. - {{data2.mobileNumber}} </b>
            </div>
        </div>
    </tbody>

</table>
</div> -->